import { UploadDealDocumentRequestPayload } from '@/pages/Deal/store/actions';
import { EntityS3RequestPayload } from '@/pages/EntityPortfolio/store/actions';
import { TransactionFilesPostRequestPayload } from '@/pages/TradeNotification/store/types';
import { FileValueForS3Sending } from '@components/FileS3Uploader/types';
import toastMessage from '@components/Toast';
import { isDefAndNotNull } from '@utils/def';
import axios, { AxiosInstance } from 'axios';

import { GetPresignedUrlResponse } from 'api/upload/types';
import { ApiResponse } from 'models/ApiResponse';

export default class UploadApi {
  client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  uploadFileToS3({ file }: { file: FileValueForS3Sending }) {
    return axios({
      method: 'put',
      url: file.url,
      data: file.data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response.data;
        }

        toastMessage.error(`File ${file.name} was not uploaded.`);

        return undefined;
      })
      .catch((error) => {
        toastMessage.error(
          `File ${file.name} was not uploaded: ${error.message}`,
        );

        return undefined;
      });
  }

  async getPresignedUrl({ file_extensions }: { file_extensions: string[] }) {
    const response = await this.client.post<
      ApiResponse<GetPresignedUrlResponse[]>
    >('/v2/reporting/get-presigned-upload-urls/', {
      file_extensions,
    });

    if (
      isDefAndNotNull(response.data) &&
      isDefAndNotNull(response.data.success) &&
      response.data.success === true
    ) {
      return response.data.data;
    }

    toastMessage.error('Invalid API response format');

    return undefined;
  }

  async uploadEntityDocument(payload: EntityS3RequestPayload) {
    return this.client.post('/v2/reporting/s3-document/', payload);
  }

  async uploadDealDocument(payload: UploadDealDocumentRequestPayload) {
    return this.client.post('/v2/reporting/s3-document/', payload);
  }

  async uploadTradeDocument(payload: TransactionFilesPostRequestPayload) {
    return this.client.post(
      `/v2/file-management/transaction/${payload.transaction_id}/files/`,
      payload,
    );
  }
}
